// import { useState } from 'react';
// import { useContext, useRef } from 'react';
// import ModalSvcContext from 'src/shared/services/modal/modal.context';
// import ModalService from 'src/shared/services/modal/modal.service';
// import APP_MODALS from 'src/static/enums/app.modals';
// import Button from 'src/components/internal/button/button.component';

// export default function ContentAcceptanceModal() {
// 	const modalRef = useRef<HTMLDivElement>(null);
// 	const modalContentRef = useRef<HTMLDivElement>(null); // Ref for modal content
// 	const modalSvc = useContext<ModalService>(ModalSvcContext);

// 	// Function to close the modal
// 	const closeModal = () => {
// 		modalSvc.closeModal(APP_MODALS.CONTENT_ACCEPTANCE_MODAL);
// 	};
// 	const [points, setPoints] = useState(0); // Initial points value
// 	const [focused, setFocused] = useState(false); // Track input focus state

// 	// Function to update points on the server (implement your API call here)
// 	const updatePoints = async (newPoints: any) => {
// 		try {
// 			// Example API call - replace with your actual implementation
// 			// await fetch('/api/update-points', {
// 			//     method: 'POST',
// 			//     body: JSON.stringify({ points: newPoints })
// 			// });
// 			console.log('Points updated:', newPoints);
// 		} catch (error) {
// 			console.error('Error updating points:', error);
// 		}
// 	};

// 	const verified = true;

// 	return (
// 		<main
// 			className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10]"
// 			tabIndex={-1}
// 			ref={modalRef}
// 		>
// 			<div
// 				ref={modalContentRef}
// 				className=" w-[343px] p-6 rounded-lg bg-white dark:bg-dark-50 min-h-[200px] md:w-[512px]"
// 			>
// 				{/* the modal gen con */}
// 				<div className="flex items-center w-full">
// 					{/* the title and the close icon */}
// 					<div className="flex items-center justify-between w-full">
// 						<h3 className="text-2xl font-bold leading-9">Accept Submission</h3>
// 						{/* icon */}
// 						<div onClick={closeModal} className="cursor-pointer">
// 							<i className="fa-solid fa-xmark "></i>
// 						</div>
// 					</div>
// 				</div>
// 				<h6 className="text-base font-normal leading-[26px] mt-6">
// 					Please assign quest points to reward the user for their contribution.
// 				</h6>
// 				<div className="flex items-center h-fit justify-between bg-gray-50 my-6 dark:bg-dark-700 dark:text-white py-[8px] px-[10px] rounded-lg w-full mt-5">
// 					{/* <span className="font-semibold text-black text-2xl dark:text-white">
// 						Total Points
// 					</span> */}
// 					<div
// 						// className={`flex h-[65px] transition duration-100 ease-in items-center space-x-6 bg-gray-100 dark:bg-dark-800 p-2 rounded-lg ${
// 						// 	focused ? 'border border-ablue-200' : ''
// 						// }`}
// 						className="flex items-center justify-between w-full"
// 					>
// 						{/* Minus Button */}
// 						<div className="relative group">
// 							<button
// 								onClick={() => {
// 									const updatedPoints = points - 50;
// 									setPoints(updatedPoints);
// 									updatePoints(updatedPoints);
// 								}}
// 								className="hover:bg-ablue-100 hover:text-white transition duration-100 ease-in-out bg-white text-black border rounded w-10 h-10 flex items-center justify-center"
// 							>
// 								–
// 							</button>
// 						</div>

// 						{/* Points Display */}
// 						<span className="font-bold text-3xl text-black flex items-center">
// 							<input
// 								type="number"
// 								value={points}
// 								onChange={(e) => setPoints(Number(e.target.value))}
// 								onFocus={() => setFocused(true)}
// 								onBlur={() => setFocused(false)}
// 								className="text-3xl bg-transparent dark:text-white text-center focus:outline-none"
// 								style={{ width: `${String(points).length + 2}ch` }}
// 								onKeyDown={(e) => {
// 									if (e.key === 'Enter') {
// 										updatePoints(points);
// 										setFocused(false);
// 									}
// 								}}
// 							/>
// 							<img
// 								src="/Points logo/points.svg"
// 								alt="Points"
// 								className="ml-1 h-7 w-7 text-blue-500"
// 							/>
// 						</span>

// 						{/* Plus Button */}
// 						<div className="relative group">
// 							<button
// 								onClick={() => {
// 									const updatedPoints = points + 50;
// 									setPoints(updatedPoints);
// 									updatePoints(updatedPoints);
// 								}}
// 								className="hover:bg-ablue-100 hover:text-white transition duration-100 ease-in-out bg-white text-black border rounded w-10 h-10 flex items-center justify-center"
// 							>
// 								+
// 							</button>
// 						</div>
// 					</div>
// 				</div>

// 				{/* the buttons */}
// 				<div className="flex items-center gap-x-3 mt-4">
// 					<Button className="secondary w-full">Reject</Button>
// 					<Button
// 						className={`w-full ${
// 							verified
// 								? 'ghostgray !text-ghostly_grey-300 dark:!bg-agrey-800 dark:border-none'
// 								: 'blue'
// 						}`}
// 						// onClick={() => open}
// 					>
// 						Accept
// 					</Button>
// 				</div>
// 			</div>
// 		</main>
// 	);
// }

import ModalSvcContext from 'src/shared/services/modal/modal.context';
import ModalService from 'src/shared/services/modal/modal.service';
import APP_MODALS from 'src/static/enums/app.modals';
import { useContext, useRef, useState } from 'react';
import Button from 'src/components/internal/button/button.component';
import { toast } from 'react-toastify';
import QueryApi from 'src/shared/api/query-api';
import { useMutation } from 'react-query';

export default function SubmissionModal() {
	const modalRef = useRef<HTMLDivElement>(null);
	const modalContentRef = useRef<HTMLDivElement>(null); // Ref for modal content
	const modalSvc = useContext<ModalService>(ModalSvcContext);

	const modalSvcData = modalSvc.getModals().value[0].data || {};

	const [points, setPoints] = useState(0); // Initial points value
	const [, setFocused] = useState(false); // Track input focus state
	const { submissionId } = modalSvcData || {};

	// alert(data);
	const closeModal = () => {
		modalSvc.closeModal(APP_MODALS.CONTENT_ACCEPTANCE_MODAL);
	};

	// Here I am letting the local storage to know that we have clicked  the accept button so that we can refetch the data on the submit content page

	const handleClick = () => {
		localStorage.setItem('modalConfirmed', 'true');
		// Manually dispatch a storage event for same-tab communication
		window.dispatchEvent(
			new StorageEvent('storage', {
				key: 'modalConfirmed',
				newValue: 'true',
			})
		);
	};

	const approveMutation = useMutation({
		mutationFn: ({ submissionId, points }: { submissionId: string; points: number }) =>
			QueryApi.admin.approveSubmission(submissionId, points),

		onSuccess: async () => {
			toast.success('Decision made successfully');
			handleClick();

			closeModal();
		},

		onError: () => {
			toast.error('Something happened');
		},
	});

	const acceptSubmission = (submissionId: string, points: number) => {
		approveMutation.mutate({ submissionId, points });
	};

	return (
		<main
			className="fixed inset-0 bg-black bg-opacity-50 pointer-events-auto flex items-center justify-center z-[10]"
			tabIndex={-1}
			ref={modalRef}
		>
			<div
				ref={modalContentRef}
				className="w-[343px] p-6 rounded-lg bg-white dark:bg-dark-800 min-h-[200px] max-h-fit md:w-[512px]"
			>
				{/* the modal gen con */}
				<div className="flex items-center w-full">
					{/* the title and the close icon */}
					<div className="flex items-center justify-between w-full">
						<h3 className="text-2xl font-bold leading-9 dark:text-white">
							Accept Submission
						</h3>
						{/* icon */}
						<button
							onClick={closeModal}
							className="text-gray-500 hover:text-gray-700 dark:text-white text-2xl flex items-center justify-center rounded-[4px] size-5 hover:bg-light-700 hover:p-2 dark:hover:bg-dark-700"
						>
							<i className="fa-solid fa-xmark text-sm"></i>
						</button>
					</div>
				</div>
				<h6 className="text-base font-normal leading-[26px] mt-6 dark:text-white">
					Please assign quest points to reward the user for their contribution.
				</h6>
				<div className="flex items-center h-fit justify-between hover:border hover:border-ablue-300 bg-gray-50 my-6 dark:bg-dark-700 dark:text-white py-[8px] px-[10px] rounded-lg w-full mt-5">
					<div className="flex items-center justify-between w-full">
						{/* Minus Button */}
						<div className="relative group">
							<button
								onClick={() => {
									const updatedPoints = points - 50;
									setPoints(updatedPoints);
								}}
								className="hover:bg-ablue-100 hover:text-white transition duration-100 ease-in-out bg-white dark:bg-dark-800 dark:text-white dark:border-none text-black border rounded w-10 h-10 flex items-center justify-center"
							>
								–
							</button>
						</div>

						{/* Points Display */}
						<span className="font-bold text-3xl text-black flex items-center">
							<input
								type="number"
								value={points}
								onChange={(e) => setPoints(Number(e.target.value))}
								onFocus={() => setFocused(true)}
								onBlur={() => setFocused(false)}
								className="text-3xl bg-transparent dark:text-white text-center focus:outline-none"
								style={{ width: `${String(points).length + 2}ch` }}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										setFocused(false);
									}
								}}
							/>
							<img
								src="/Points logo/points.svg"
								alt="Points"
								className="ml-1 h-7 w-7 dark:hidden text-blue-500"
							/>
							{/* the dark icon */}
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="22"
								viewBox="0 0 16 22"
								fill="none"
								className="hidden dark:block"
							>
								<path
									d="M15.8239 7.25434C15.5399 6.68634 14.9679 6.33301 14.3332 6.33301H10.7959L12.2466 2.60234C12.4452 2.08901 12.3786 1.51167 12.0679 1.05701C11.7572 0.603674 11.2426 0.333008 10.6932 0.333008H5.13323C4.43723 0.333008 3.80789 0.771674 3.5679 1.42501L0.387895 10.093C0.201228 10.6037 0.277228 11.1757 0.587895 11.621C0.899895 12.0663 1.41056 12.3317 1.95323 12.3317H7.00656L4.70389 20.3903C4.57056 20.8543 4.78789 21.3463 5.21989 21.561C5.36256 21.6317 5.51456 21.665 5.66523 21.665C5.97056 21.665 6.27056 21.5237 6.46523 21.265L15.6679 8.99967C16.0479 8.49167 16.1079 7.82367 15.8239 7.25434Z"
									fill="#AE9CFE"
								/>
							</svg>
						</span>

						{/* Plus Button */}
						<div className="relative group">
							<button
								onClick={() => {
									const updatedPoints = points + 50;
									setPoints(updatedPoints);
								}}
								className="hover:bg-ablue-100 hover:text-white transition duration-100 ease-in-out bg-white dark:bg-dark-800 dark:text-white dark:border-none text-black border rounded w-10 h-10 flex items-center justify-center"
							>
								+
							</button>
						</div>
					</div>
				</div>

				{/* the buttons */}
				<div className="flex items-center gap-x-3 mt-4">
					<Button className="secondary w-full" onClick={closeModal}>
						Reject
					</Button>
					<Button
						className="blue w-full text-ghostly_grey-300 dark:!bg-agrey-800 dark:border-none"
						onClick={() => acceptSubmission(submissionId, points)}
					>
						Accept
					</Button>
				</div>
			</div>
		</main>
	);
}
